import {STATUS, STATUS_NAMES} from "./types/enums";

interface Item extends Record<string, unknown> {
    item_id: number
    process_completed: boolean
    process_status?: string
    form_status: number
}

export const getProcessStatus = (item: Item): string | STATUS_NAMES => {
    if (item.process_completed) {
        return STATUS_NAMES['Closed'];
    }

    if (item.process_status) {
        return item.process_status;
    }

    return STATUS_NAMES?.[STATUS?.[item?.form_status]] ?? 'Неизвестно';
}
